export const lang = process.env.REACT_APP_LANG;
export const name = process.env.REACT_APP_NAME;
export const apiURL = process.env.REACT_APP_API_URL;
export const secretKey = process.env.REACT_APP_KEY || 'example key';
export const currency = process.env.CURRENCY || 'CHF'